import {  WorkCalenderResponse } from "@gtpl/shared-models/hrms";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { WorkCalenderDto } from "./dto/work-calender.dto";
import { WorkCalenderRequest } from "./dto/work-calender.request";
import { WorkCalenderService } from "./work-calender.service";

@ApiTags('workcalender')
@Controller('workcalender')
export class WorkCalenderController {

    constructor(
        private service: WorkCalenderService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createWorkCalender')
    async createWorkCalender(@Body() DTO: WorkCalenderDto, isUpdate: boolean = false): Promise<WorkCalenderResponse>{
        try{
            return await this.service.createWorkCalender(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(WorkCalenderResponse, error);
        }
    }

    @Post('/updateWorkCalender')
    async updateWorkCalender(@Body() DTO: WorkCalenderDto, isUpdate: boolean = false): Promise<WorkCalenderResponse>{
        try{
            return await this.service.createWorkCalender(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(WorkCalenderResponse, error);
        }
    }

    
    @Post('/getAllWorkCalender')
    async getAllWorkCalender(): Promise<WorkCalenderResponse>{
        try{
            return await this.service.getAllWorkCalender();
        }catch(error){
            return this.applicationExceptionHandler.returnException(WorkCalenderResponse, error);
        }
    }

    @Post('/getAllActiveWorkCalender')
    async getAllActiveWorkCalender(): Promise<WorkCalenderResponse>{
        try{
            return await this.service.getAllActiveWorkCalender();
        }catch(error){
            return this.applicationExceptionHandler.returnException(WorkCalenderResponse, error);
        }
    }

    @Post('/activateOrDeactivateWorkCalender')
    async activateOrDeactivateWorkCalender(@Body() workcalenderReq: WorkCalenderRequest): Promise<WorkCalenderResponse>{
        try{
            return await this.service.activateOrDeactivateWorkCalender(workcalenderReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(WorkCalenderResponse, error);
        }
    }
}